export default __webpack_public_path__ + "static/media/RobotoMono-Regular.86ff6131.ttf";